import { trackingData } from "./tracking";
import { getPropsForClickTracking } from "../../utils/tracking";

<div data-testid="load-more" class=["load-more", input.isMoreResultsBannerVisible && "load-more-with-banner"]>
  <ebay-button
    data-testid="load-more-button"
    priority="tertiary"
    on-click("onLoadClickHandler")
    ...getPropsForClickTracking([trackingData(input.entryPageId)])
  >
    <${input.renderBody}/>
  </ebay-button>
</div>
